import { FC } from 'react';

export const LeftAlignIcon: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <line x1="3" y1="6" x2="21" y2="6"></line>
    <line x1="3" y1="10" x2="15" y2="10"></line>
    <line x1="3" y1="14" x2="21" y2="14"></line>
    <line x1="3" y1="18" x2="15" y2="18"></line>
  </svg>
);
